<div class="content-stats-providers">
    <router-outlet></router-outlet>
</div>
